// extracted by mini-css-extract-plugin
export default {"image":"i4LSZOPEwq","thumbnail":"bZtj4BObVN"};